import { Box, Layer, Spinner, Text } from "grommet";
import React from "react";
import LoadingIcon from '../../../../../assets/imagesLOad.svg';
import './SpinnerLoader.css';

function SpinnerLoader() {
  const styles = {
    main: {
      padding: '40px 60px',
      borderRadius: '12px',
      width: 187,
      height: 164
    },
    loadingTxt: {
    color: '#4B628A',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '16px',
    marginTop: "2px"
    },
    loadingImg: {
      width: 90
    }
  };
  return (
    <Layer className="outer-box">
      <Box
        align="center"
        justify="center"
        gap="small"
        alignSelf="center"
        pad="large"
        style={styles.main}
      > 
        <img style={styles.loadingImg} src={LoadingIcon} alt="loading icon" />
        <Text style={styles.loadingTxt}>Loading...</Text>
      </Box>
    </Layer>
  );
}

export default SpinnerLoader;
